import { VERIFICAR_VINCULO_ITINERARIO_e_MOTORISTA } from '../../actions/types'

const initialState = false;


export default function reducerVerificarVinculoItinerarioEMotorista (state = false, action = initialState) {
  switch (action.type) {
    case VERIFICAR_VINCULO_ITINERARIO_e_MOTORISTA: {

      if (action.payload) {
        return action.payload.data;
      }      

      return state
    }

    default: {
      return state
    }
  }
}
